import angular from 'angular'

import routes from './routes'

import rootCtrl from './root.controller'
import routingRoutes from './routing.routes'
import routingRun from './routing.run'

import homeMenu from './menus/home.menu'
import mainMenu from './menus/main.menu'

import accountModule from './account/account.module'
import consultModule from './consult/consult.module'
import invoicingModule from './invoicing/invoicing.module'
import maneuverModule from './maneuver/maneuver.module'
import scrappingModule from './scrapping/scrapping.module'
import settingModule from './setting/setting.module'

// import testModule from './test/test.module'

const name = 'routing'

angular.module(name, [
  accountModule,
  consultModule,
  scrappingModule,
  maneuverModule,
  settingModule,
  // testModule,
  invoicingModule,
])
  .config(routingRoutes)
  .run(routingRun)
  .controller('rootCtrl', rootCtrl)
  .factory('homeMenu', homeMenu)
  .factory('mainMenu', mainMenu)
  .factory('routes', () => {
    return routes
  })

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/routing.module.js